import { useNavigate } from "react-router-dom"
import Header from "../../components/Header/Header"
import SideNavbar from "../../components/Navbar/SideNavbar"
import PromoCodeListData from "../../components/PromoCodeList/PromoCodeListData"
import { useEffect, useState } from "react"
import axios from "../../../core/services/axiosConfig"

// Add type for props

const INPUT_CLASS = "border border-gray-300 h-8 rounded-sm focus:outline-none focus:border-blue-400 px-1.5 text-xs w-full";
const SELECT_CLASS = "bg-white border border-gray-300 h-8 w-full focus:outline-none focus:border-blue-400 px-1.5 rounded-sm text-xs";

const PromoCodeList = () => {
    const navigate = useNavigate();
    const [activeByDate, setActiveByDate] = useState("")
    const [expiredByDate, setExpiredByDate] = useState("")
    const [clearTrigger, setClearTrigger] = useState(false);
    const [filters, setFilters] = useState({ activeByDate: "", expiredByDate: "",selectedOption:'',filterValue:'',filterPromoCode:'' })
    const [selectedOption, setSelectedOption] = useState('');
    const [filterValue, setInputValue] = useState('');
    const [filterPromoCode, setFilterPromoCode] = useState("")
    const [filterKey, setDropdownValue] = useState('');
    const [shouldDownloadDump, setShouldDownloadDump] = useState(false)

    const handleDownloadDump = () => {
        setShouldDownloadDump(true)
    }

    // Dropdown options for demo (can be dynamic or fetched)
    const paymentOptions = [
        {label:"PREPAID",value:"PREPAID"},
        {label:"POSTPAID",value:"POSTPAID"}
    ];

    const [categories, setCategories] = useState<any[]>([]);
    const [brands, setBrands] = useState<any[]>([]);

    useEffect(()=>{
        getBrand();
        getAllCategories();
    },[])

    const getBrand = async () => {

        try {
            const response = await axios.get(`${process.env.REACT_APP_CMS_SERVICE}/cmsApi/v1/promocode/getbrands`);
            const formattedBrands = response.data.data.map((brand: any) => ({
                value: brand.idBrand,
                label: brand.brandName,
            }));
            setBrands(formattedBrands);
        } catch (error) {
            console.error("Error fetching brands:", error);
        }
    };



    const getAllCategories = async () => {

        try {
            const response = await axios.get(`${process.env.REACT_APP_CMS_SERVICE}/cmsApi/v1/promocode/getcategories`);
            const formattedCategories = response.data.data.map((cat: any) => ({
                value: cat.categoryCode,
                label: cat.categoryName,
            }));
            setCategories(formattedCategories);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const createFbtHandler = () => {
        navigate("/promocode-list/create");
    }
    const handleGo = () => {
        setFilters({ activeByDate, expiredByDate ,selectedOption,filterValue,filterPromoCode })
    }
    const handleClear = () => {
        setActiveByDate("");
        setExpiredByDate("");
        setInputValue("");
        setSelectedOption("");
        setFilterPromoCode("");
        setFilters({ activeByDate: "", expiredByDate: "" ,selectedOption:'',filterValue:'',filterPromoCode :''});
        setClearTrigger((prev) => !prev);
    }

    const hasActiveFilters = !!(activeByDate || expiredByDate || filterPromoCode || selectedOption || filterValue
        || filters.activeByDate || filters.expiredByDate || filters.filterPromoCode || filters.selectedOption || filters.filterValue);

    const handleSelectChange = (e:any) => {
        setSelectedOption(e.target.value);
        setInputValue('');
    };

    // Render the appropriate input or dropdown based on selection
    const renderInputField = () => {
        if (!selectedOption) return null;

        const field = ['USER', 'CART', 'PRODUCT'].includes(selectedOption) ? (
            <input
                type="text"
                className={INPUT_CLASS}
                placeholder={`Enter ${selectedOption.toLowerCase()}`}
                value={filterValue}
                onChange={(e: any) => setInputValue(e.target.value)}
            />
        ) : selectedOption === 'CATEGORY' ? renderDropdown(categories)
            : selectedOption === 'BRAND' ? renderDropdown(brands)
                : selectedOption === 'PAYMENT' ? renderDropdown(paymentOptions)
                    : null;

        if (!field) return null;

        // The value field only makes sense next to the type it belongs to, so
        // it is labelled with that type rather than left unlabelled.
        return (
            <div className="w-[180px]">
                <label className="block text-[11px] text-gray-600 mb-1">{selectedOption.charAt(0) + selectedOption.slice(1).toLowerCase()}</label>
                {field}
            </div>
        );
    };

    const renderDropdown = (options:any) => (
        <select
            className={SELECT_CLASS}
            value={filterValue}
            onChange={(e:any) => setInputValue(e.target.value)}
        >
        <option value="">Select</option>
            {options.map((opt:any,index: number) => (
                <option key={index} value={opt.value}>
                {opt.label}
                </option>
            ))}
        </select>
    );

    return (
        <div className="flex mainWrapper w-full">
            <div className="sidenav-wrapper">
                <SideNavbar />
            </div>
            <div className="right-container">
                <div className="header-container">
                    <Header />
                </div>
                <div className="body-container">
                    <div className="p-4">
                        <div className="flex items-center justify-between w-full">
                            <p className="text-xl font-bold text-[#43425D]">PROMOCODE LIST</p>
                            <div className="flex items-center gap-4">
                                <button onClick={createFbtHandler} className="h-9 py-2 px-4 bg-blue-500 text-white font-semibold rounded shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75">Create PromoCode</button>
                                <button onClick={handleDownloadDump} disabled={shouldDownloadDump} className="h-9 py-2 px-4 bg-blue-500 text-white font-semibold rounded shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 disabled:opacity-50" >
                                    {shouldDownloadDump ? "Downloading..." : "Download Dump"}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="mt-2.5 bg-white px-4 py-3 flex flex-wrap items-end gap-x-4 gap-y-3">
                        <div className="w-[160px]">
                            <label className="block text-[11px] text-gray-600 mb-1">Active By</label>
                            <input
                                className={INPUT_CLASS}
                                type="date"
                                value={activeByDate}
                                onChange={e => setActiveByDate(e.target.value)}
                            />
                        </div>
                        <div className="w-[160px]">
                            <label className="block text-[11px] text-gray-600 mb-1">Expired By</label>
                            <input
                                className={INPUT_CLASS}
                                type="date"
                                value={expiredByDate}
                                onChange={e => setExpiredByDate(e.target.value)}
                            />
                        </div>
                        <div className="w-[200px]">
                            <label className="block text-[11px] text-gray-600 mb-1">Promo Code</label>
                            <input
                                className={INPUT_CLASS}
                                type="text"
                                placeholder="Filter by promo code"
                                value={filterPromoCode}
                                onChange={e => setFilterPromoCode(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && handleGo()}
                            />
                        </div>
                        <div className="w-[160px]">
                            <label className="block text-[11px] text-gray-600 mb-1">Filter By</label>
                            <select
                                className={SELECT_CLASS}
                                name="device"
                                value={selectedOption}
                                onChange={handleSelectChange}
                            >
                                <option value="">All</option>
                                <option value="USER">USER</option>
                                <option value="CART">CART</option>
                                <option value="CATEGORY">CATEGORY</option>
                                <option value="BRAND">BRAND</option>
                                <option value="PRODUCT">PRODUCT</option>
                                <option value="PAYMENT">PAYMENT</option>
                            </select>
                        </div>
                        {renderInputField()}

                        <button onClick={handleGo} className="h-8 px-5 rounded text-xs font-semibold bg-blue-500 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75">Go</button>
                        <button onClick={handleClear} disabled={!hasActiveFilters} className="h-8 px-4 rounded text-xs font-medium bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-40 disabled:cursor-not-allowed">Clear</button>
                    </div>
                    <PromoCodeListData activeByDate={filters.activeByDate} expiredByDate={filters.expiredByDate} filterKey={filters.selectedOption} filterValue={filters.filterValue} filterPromoCode={filters.filterPromoCode} shouldDownloadDump={shouldDownloadDump} onDumpHandled={() => setShouldDownloadDump(false)}  />
                </div>
            </div>
        </div>
    )
}
export default PromoCodeList;

